import { ref } from 'vue';
import { OPEN_MODAL_SYMBOL } from '~/components/navigation/symbols';

export default defineNuxtPlugin((nuxtApp) => {
  // Provide a shared ref for the user modal open state at app level
  const isUserModalOpen = ref<boolean>(false);
  nuxtApp.vueApp.provide(OPEN_MODAL_SYMBOL, isUserModalOpen);

  return {
    provide: {
      // optional: expose via Nuxt provide as well
      userModal: isUserModalOpen,
    },
  };
});
